import { render, staticRenderFns } from "./NotificationsPage.vue?vue&type=template&id=70a67cc8&scoped=true"
import script from "./NotificationsPage.vue?vue&type=script&lang=js"
export * from "./NotificationsPage.vue?vue&type=script&lang=js"
import style0 from "./NotificationsPage.vue?vue&type=style&index=0&id=70a67cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a67cc8",
  null
  
)

export default component.exports